document.addEventListener("DOMContentLoaded", () => {
  const accElements = document.querySelectorAll(".accordion-trigger");

  accElements.forEach(acc => {
    acc.addEventListener("click", () => {
      const nextEl = acc.nextElementSibling;

      if (nextEl) {
        nextEl.classList.toggle("is-open");
        acc.classList.toggle("active");
      }
    });
  });
});